import React from 'react';
import Link from 'next/link';
import useWidth from '@/helpers/widthUtil';
import AvatarComponent from '@/components/common/avatar';
import ReadMore from '@/components/common/read-more';
import { Row } from 'reactstrap';

const TutorListView = ({ tutors, type }) => {
  const { isMobile } = useWidth();
  const data = tutors.map((tutor, i) => ({
    index: i,
    avatar: (
      <div>
        <AvatarComponent
          firstName={tutor?.first_name}
          lastName={tutor?.last_name}
          avatar={tutor?.avatar}
          size={40}
          biggerAvatar={true}
        />
      </div>
    ),
    biography: tutor?.biography,
    username: tutor?.username,
    name: tutor?.name,
    first_name: tutor?.first_name,
    last_name: tutor?.last_name,
    twitter: tutor?.twitter,
    linkedin: tutor?.linkedin,
  }));

  return (
    <Row>
      {data?.map((item) => (
        <div className="mb-4 col-lg-12 col-sm-12" key={item?.index}>
          <div className="bg-light border-14 p-3">
            <div className="d-flex">
              <span className="mr-2">{item?.avatar}</span>
              <div className="d-flex flex-column m-2">
                <Link href={`/tutor/${item?.username}`}>
                  <a>
                    <h5 className="text-dark mb-2 pb-2 my-auto font-weight-normal font-size-small">
                      {type == 'instructor'
                        ? item?.name
                        : item?.first_name + ' ' + item?.last_name}
                    </h5>
                    {/* <div className="instructor-social">
                       <ul className="social list-unstyled list-inline">
                         {item?.twitter ? (
                           <li className="list-inline-item">
                           <a href={item?.twitter} target="_blank">
                           <TwitterCircleFilled />
                           </a>
                           </li>
                           ) : (
                             ''
                             )}
                             {item?.linkedin ? (
                               <li className="list-inline-item">
                               <a href={item?.linkedin} target="_blank">
                               <LinkedinFilled />
                             </a>
                             </li>
                             ) : (
                               ''
                               )}
                               </ul>
                     </div> */}
                  </a>
                </Link>
                <ReadMore
                  style={{ fontSize: '14px' }}
                  className={`text-justify text-black`}
                  text={item?.biography}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </Row>
  );
};

export default TutorListView;
